// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__x9kxJ","item":"styles_item__xhXmq","link":"styles_link__enann","title":"styles_title__90LrK"};